var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React from 'react';
import { observer } from 'mobx-react';
import Select from 'react-select';
import { injectIntl } from 'react-intl';
import classNames from 'classnames';
import { ApplicationContext } from '../../../../ApplicationContext';
import AssetOption from './AssetOption';
/**
 *
 */
var AssetSearch = /** @class */ (function (_super) {
    __extends(AssetSearch, _super);
    /**
     *
     * @param props
     */
    function AssetSearch(props) {
        var _this = _super.call(this, props) || this;
        _this.onChange = _this.onChange.bind(_this);
        _this.onUpdate = _this.onUpdate.bind(_this);
        _this.state = {};
        return _this;
    }
    /**
     *
     * @return {*}
     */
    AssetSearch.prototype.render = function () {
        var _a = this.props, name = _a.name, intl = _a.intl, className = _a.className, value = _a.value;
        var _b = this.state;
        var classes = classNames({ 'w-100': true }) + ' ' + className;
        return (React.createElement("div", { className: "asset-search d-flex flex-wrap ".concat(classes) },
            React.createElement("div", { className: "asset-search__input-wrapper w-100" },
                React.createElement(Select, { className: "form-control select2", classNamePrefix: "select2", name: name, placeholder: intl.formatMessage({ id: 'asset.search' }), noOptionsMessage: function () {
                        return intl.formatMessage({ id: 'asset.noresults' });
                    }, components: { Option: AssetOption }, isSearchable: true, isMulti: this.props.isMulti, options: this._createOptions(), onChange: this.onChange, isOptionDisabled: function (option) { return option.value == null || option.isDisabled; } }))));
    };
    /**
     *
     * @param option Array|any
     */
    AssetSearch.prototype.onChange = function (options) {
        if (this.props.onChange) {
            if (options instanceof Array) {
                this.props.onChange(options.map(function (option) { return option.model; }));
            }
            else if (options) {
                this.props.onChange([options.model]);
            }
            else {
                this.props.onChange([]);
            }
        }
    };
    /**
     *
     * @param labelModel
     */
    AssetSearch.prototype.onUpdate = function (labelModel) {
    };
    /**
     *
     * @return {{label: (*|string), value: *}[]|Array}
     * @private
     */
    AssetSearch.prototype._createOptions = function () {
        var _a = this.props, assetCollection = _a.assetCollection, disableIds = _a.disableIds;
        var options = assetCollection.list
            .map(function (model) {
            return {
                value: model.id,
                label: model.id,
                model: model,
                isDisabled: disableIds.indexOf(model.id) >= 0
            };
        });
        options.unshift({ value: null, label: null, model: null, isDisabled: false });
        return options;
    };
    AssetSearch.defaultProps = {
        className: '',
        disableIds: []
    };
    AssetSearch = __decorate([
        observer
    ], AssetSearch);
    return AssetSearch;
}(React.Component));
AssetSearch.contextType = ApplicationContext;
export default injectIntl(AssetSearch);
